
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'Nav',
  props: {
    msg: String
  },
  computed: {
    ...mapState(['userInfo'])
  }
});
